export class FetchError extends Error {
    public code: number | undefined;
    public body: Promise<any> | any | undefined;

    constructor(message: string, code?: number, body?: Promise<any>) {
        super(message);

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, FetchError);
        }

        this.name = this.constructor.name;
        this.code = code;
        this.body = body;
    }
}
